import {createContext, useContext, useMemo, useState} from "react";

const BasketContext = createContext();

export const BasketProvider = ({ children }) => {
    const [basketVersion, setBasketVersion] = useState(0); // 0 on mount

    const bumpBasketVersion = () => setBasketVersion(v => v + 1);

    const value = useMemo(
        () => ({ basketVersion, bumpBasketVersion }),
        [basketVersion]
    );

    return <BasketContext.Provider value={value}>{children}</BasketContext.Provider>;
};

export const useBasket = () => useContext(BasketContext);
